import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(private apiService: ApiService) {}

  changePassword(data): Observable<any> {
    const url = '/changePassword';
    return this.apiService.patch(url, data);
  }
}
